import { getHome } from '@/common/requests/data-fetch/get-home'
import { FETCH_CATEGORY } from '@/common/utils/store.const'

const state = {
  category: undefined,
}

const getters = {
  category() {
    return state.category
  },
}

const actions = {
  async [FETCH_CATEGORY]({ commit }) {
    const { data } = await getHome()
    commit('setCategory', data?.layout)
  },
}

const mutations = {
  /**
   * @param {*} state
   * @param {object} payload { category: object }
   */
  setCategory(state, payload) {
    state.category = payload?.category
  },
}

export default { state, getters, actions, mutations }
